import React, { useState } from 'react';
// import classes from './SideBar.module.css';
import SideBar from './SideBar';
import WardPaginator from './WardPaginator';
import '../../../styles/App.css'
import addPatient from './../../../images/add_patient.png'
import MyModal from '../MyModal/MyModal';
import AddNewPatient from '../../AddNewPatient';


const CabinetSideBar = ({ currentWard, setCurrentWard }) => {
    const [addPatientVisible, setAddPatientVisible] = useState(false);
    return (
        <div className='sidebar'>
            <SideBar />
            <WardPaginator
                currentWard={currentWard}
                setCurrentWard={setCurrentWard}
            />
            <div
                className='addPatient_btn'
                onClick={() => setAddPatientVisible(true)}
            >
                <img src={addPatient} style={{ margin: "20px" }} />
                <div style={{ marginTop: "10px", fontSize: "32px", textAlign: "center" }}>Добавить пациента</div>
            </div>
            <MyModal
                visible={addPatientVisible}
                setVisible={setAddPatientVisible}
                // style={{ width: "100%" }}
            >
                <AddNewPatient setAddPatientVisible={setAddPatientVisible}/>
            </MyModal>
        </div>
    );
};

export default CabinetSideBar;